// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cx from "rescript-classnames/src/Cx.bs.js";
import * as React from "react";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function Link(Props) {
  var path = Props.path;
  var active = Props.active;
  var children = Props.children;
  return React.createElement("button", {
              className: Cx.cx([
                    "link",
                    active ? "active" : ""
                  ]),
              type: "button",
              onClick: (function (param) {
                  return RescriptReactRouter.push("#" + path);
                })
            }, children);
}

var make = Link;

export {
  make ,
  
}
/* react Not a pure module */
